import styled from 'styled-components';

const Container = styled.div`
  padding: 0 0.5rem;
  @media (min-width: 1281px) {
    padding: 0 12rem;
  }
`;

export default Container;
